module.exports = __webpack_public_path__ + "static/media/2.d84f52f1.jpg";